// extracted by mini-css-extract-plugin
module.exports =  {"error-response":"server_errors__error-response___bXq84","errorResponse":"server_errors__error-response___bXq84"};